define(['./ViewModel', 'edge/platform/metamirror/InsuranceSuiteMetadataService'], (ViewModel)=> {
    return ['InsuranceSuiteMetadata', (InsuranceSuiteMetaDataService)=> {
        // return the service instance
        return ViewModel.get(InsuranceSuiteMetaDataService);
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/viewmodel/ViewModelService.js